module.exports = __webpack_public_path__ + "4a6d8be390fad39c44ca05cb834c804e.png";